<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loanTemplateService } from "../../../../services/paymentservice/loantemplate.service";
import { settingService } from "../../../../services/settingservice/setting.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Loan Templates List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      templatesList: {},
      loanTypesList: {},
      fetchingStats: false,
      title: "Loan Templates List",

    };
  },
  mounted() {
    
    this.loadingLoanTypeData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '?page=0') {
      this.fetchingStats = false;
      loanTemplateService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.templatesList = response;
        });
    },

    loadingLoanTypeData: function() {
      settingService.getLoanTypeList()
        .then(response => {
          this.loanTypesList = response;

        });
    },

    deleted: function(id) {
      loanTemplateService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-loan-template-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-loan-template-add'}" :title="$t('setting.configuration.loan-template.text')" />
    <List v-bind:dataList="templatesList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'number_month', type: 'suffix', sign: ' ' + $t('general.month')}, {name: 'monthly_pay', type: 'currency', sign: '$'}, 
                  {name: 'rate', type: 'suffix', sign: '% / ' + $t('general.month')}]"
          v-bind:fields="[ `name: ${$t('setting.configuration.loan-template.text')}`,
            `loan_type: ${$t('setting.configuration.loan-template.type')}`, `decimal_calc_type: ${$t('setting.configuration.loan-template.round-role')}`, 
            `rate: ${$t('setting.configuration.loan-template.rate')}`, `monthly_pay: ${$t('setting.configuration.loan-template.monthly-pay')}`, 
            `number_month: ${$t('setting.configuration.loan-template.duration')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-loan-template-edit'}"
          v-bind:filter="{
            search: ['loan_templates.name', 'loan_templates.name_en'],
            dropdown: [{
              title: 'setting.configuration.loan-template.type',
              field: 'loan_templates.loan_type_id',
              data: this.loanTypesList.data,
            }],

          }"
          
    />      
  </Layout>
</template>